import { create } from "zustand";

export const useStore = create((set) => ({
  subscriptionType: 0,
  setSubscriptionType: (newCode) =>
    set((state) => ({ subscriptionType: newCode })),
}));
